<!-- Analyses Page -->
<div class="ks-page-table space-y-6">
  <!-- Error Message -->
  @if (error()) {
  <app-inline-notice tone="error" [message]="error()" />
  }

  <!-- Analysis Table (with integrated create dialog) -->
  @if (organizationId()) {
  <app-analysis-table
    [isLoading]="isLoading()"
    [organizationId]="organizationId()"
    [selectable]="true"
    [columnVisibility]="columnVisibility"
    (analysisCreated)="onAnalysisCreated($event)"
    (dataChanged)="loadAnalyses()"
  />
  }
</div>
